var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AbstractSubject_observers;
class AbstractSubject {
    constructor() {
        _AbstractSubject_observers.set(this, []);
    }
    get observers() {
        return __classPrivateFieldGet(this, _AbstractSubject_observers, "f");
    }
    attach(observer) {
        if (__classPrivateFieldGet(this, _AbstractSubject_observers, "f").includes(observer)) {
            return;
        }
        __classPrivateFieldGet(this, _AbstractSubject_observers, "f").push(observer);
    }
    detach(observer) {
        __classPrivateFieldSet(this, _AbstractSubject_observers, __classPrivateFieldGet(this, _AbstractSubject_observers, "f").filter((o) => o !== observer), "f");
    }
    notify(event = undefined) {
        for (const observer of __classPrivateFieldGet(this, _AbstractSubject_observers, "f")) {
            const argument = event instanceof CustomEvent ? event : this;
            observer.update(argument);
        }
    }
}
_AbstractSubject_observers = new WeakMap();
export default AbstractSubject;
